/**
 * 챗봇에서 영업허가 입지점검 페이지로 이동할 때 사용하는 URL.
 * CRA: REACT_APP_PERMIT_URL 빌드 시 주입.
 * 기본값은 상대 경로 — dev(:8443)·운영(443) 동일 이미지에서 현재 origin 기준으로 이동.
 */
import { openAppUrlInNewTab } from './openAppUrl';

const DEFAULT_PERMIT_URL = '/permit/';

/** predefinedQuestions 배열에서 영업허가 입지점검 카드 인덱스 */
export const PERMIT_PREDEFINED_QUESTION_INDEX = 3;

export function getPermitUrl(): string {
  const raw = process.env.REACT_APP_PERMIT_URL;
  if (typeof raw === 'string' && raw.trim() !== '') {
    const u = raw.trim();
    return u.endsWith('/') ? u : `${u}/`;
  }
  return DEFAULT_PERMIT_URL;
}

export function openPermitPage(): void {
  openAppUrlInNewTab(getPermitUrl());
}

/** "영업허가 입지점검" 추천 카드 여부 판별 */
export function isPermitShortcutCard(text: string): boolean {
  const s = (text || '').toLowerCase().replace(/\s+/g, '');
  if (!s) return false;
  return [
    '영업허가입지점검',
    '입지점검',
    'permit',
    'businesspermit',
    'locationcheck',
    '営業許可',
    '立地検査',
    '立地チェック',
    '营业许可',
    '立地检查',
  ].some((k) => s.includes(k.toLowerCase().replace(/\s+/g, '')));
}
